package com.castly.shared.dto

import kotlinx.serialization.Serializable

@Serializable
data class LabelDto(
    val id: Int,
    val name: String,
    val description: String? = null,
    val logoUrl: String? = null,
    val isActive: Boolean = true,
    val userCount: Int = 0,
    val audiobookCount: Int = 0,
    val createdAt: String? = null
)

@Serializable
data class LabelDetailDto(
    val id: Int,
    val name: String,
    val description: String? = null,
    val logoUrl: String? = null,
    val isActive: Boolean = true,
    val userCount: Int = 0,
    val audiobookCount: Int = 0,
    val createdAt: String? = null,
    val users: List<LabelUserDto> = emptyList()
)

@Serializable
data class CreateLabelRequest(
    val name: String,
    val description: String? = null,
    val logoUrl: String? = null
)

@Serializable
data class UpdateLabelRequest(
    val name: String? = null,
    val description: String? = null,
    val logoUrl: String? = null
)

@Serializable
data class LabelUserDto(
    val userId: String,
    val email: String,
    val role: String? = null,
    val labelId: Int,
    val labelName: String,
    val assignedAt: String? = null
)

@Serializable
data class CreateLabelUserRequest(
    val email: String
)

@Serializable
data class AssignUserToLabelRequest(
    val labelId: Int
)
